import React from 'react'

const ErrorComponent = (props) => {

    return (
        <div className="alert alert-danger alert-dismissible fade show">
            {props.text}
        </div>
    )
}

export default ErrorComponent